
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EnterpriseGetAllSkillPathways"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"VerifiedSkills"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllSkillPathwaysByProgramId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyLearning_SkillPathway"},"directives":[]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MyLearning_SkillPathway"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerifiedSkills_SkillPathway"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"badgeTemplateId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"skillAreasWithUserData"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyLearning_SkillAreaWithUserData"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MyLearning_SkillAreaWithUserData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerifiedSkills_SkillAreaWithUserData"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skillArea"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyLearning_SkillArea"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MyLearning_SkillArea"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerifiedSkills_SkillArea"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"course"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyLearning_SkillAreaCourse"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MyLearning_SkillAreaCourse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Course_Course"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":652}};
    doc.loc.source = {"body":"query EnterpriseGetAllSkillPathways($programId: ID!) {\n  VerifiedSkills {\n    getAllSkillPathwaysByProgramId(programId: $programId) {\n      ...MyLearning_SkillPathway\n    }\n  }\n}\n\nfragment MyLearning_SkillPathway on VerifiedSkills_SkillPathway {\n  badgeTemplateId\n  skillAreasWithUserData {\n    ...MyLearning_SkillAreaWithUserData\n  }\n}\n\nfragment MyLearning_SkillAreaWithUserData on VerifiedSkills_SkillAreaWithUserData {\n  skillArea {\n    ...MyLearning_SkillArea\n  }\n}\n\nfragment MyLearning_SkillArea on VerifiedSkills_SkillArea {\n  course {\n    ...MyLearning_SkillAreaCourse\n  }\n}\n\nfragment MyLearning_SkillAreaCourse on Course_Course {\n  id\n  slug\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["EnterpriseGetAllSkillPathways"] = oneQuery(doc, "EnterpriseGetAllSkillPathways");
        
        module.exports["MyLearning_SkillPathway"] = oneQuery(doc, "MyLearning_SkillPathway");
        
        module.exports["MyLearning_SkillAreaWithUserData"] = oneQuery(doc, "MyLearning_SkillAreaWithUserData");
        
        module.exports["MyLearning_SkillArea"] = oneQuery(doc, "MyLearning_SkillArea");
        
        module.exports["MyLearning_SkillAreaCourse"] = oneQuery(doc, "MyLearning_SkillAreaCourse");
        
